module.exports = __webpack_public_path__ + "img/hook_KONDOTEC_4.c70cfecd.png";